import styled from '@emotion/styled'
import { FilterList } from '@mui/icons-material'
import {
  Button as MuiButton,
  Checkbox,
  ListSubheader,
  Menu,
  MenuItem,
  Radio,
  Typography,
} from '@mui/material'
import { Box, spacing } from '@mui/system'
import React from 'react'

const Button = styled(MuiButton)(spacing)
const SmallButton = styled(Button)`
  padding: 4px;
  min-width: 0;

  svg {
    width: 0.9em;
    height: 0.9em;
  }
`

type Filter = {
  title: string
  selectedIds: string[]
  type?: 'radio' | 'checkbox'
  options: { id: string; label: string }[]
  onSelect: (id: string) => void
}

type BigFilterProps = {
  sections: Filter[]
}

export const BigFilter: React.FC<BigFilterProps> = props => {
  const { sections } = props
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <SmallButton
        size="small"
        mr={2}
        variant="contained"
        color="secondary"
        aria-owns={anchorEl ? 'simple-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <FilterList />
      </SmallButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {sections.map(section => (
          <Box key={section.title}>
            <ListSubheader key={section.title}>{section.title}</ListSubheader>
            {section.options.map(o => (
              <MenuItem key={o.id} onClick={() => section.onSelect(o.id)}>
                {section.type === 'radio' ? (
                  <Radio checked={section.selectedIds.includes(o.id)} />
                ) : (
                  <Checkbox checked={section.selectedIds.includes(o.id)} />
                )}
                <Typography>{o.label}</Typography>
              </MenuItem>
            ))}
          </Box>
        ))}
      </Menu>
    </>
  )
}
